import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptCommonChatAiModule } from "@common/lib/chat-ai/chat-ai.module";
import { ChatAiApplicationBarItem } from "@common/lib/chat-ai/chat-ai-application-bar-item/chat-ai-application-bar-item";
import { provideChatAiOrgProvider } from "@common/lib/chat-ai/chat-ai-org-provider.interface";
import { ChatAiSidebarTab } from "@common/lib/chat-ai/chat-ai-sidebar-tab";
import { provideApplicationBarItemType } from "@common/shell/application-bar/application-bar.component";
import { provideSidebarTab } from "@common/shell/common-sidebar/sidebar-tab";
import { AdaptStyledDashboardElementModule } from "@common/ux/styled-dashboard-element/styled-dashboard-element.module";
import { ChatAiOrgService } from "@org-common/lib/chat-ai-org-provider-impl/chat-ai-org.service";
import { AdaptOrgCommonPagesModule } from "@org-common/lib/pages/pages.module";
import { provideThemeTestPage } from "@org-common/lib/pages/theme-test/theme-test-page";
import { AdaptWorkflowModule } from "@org-common/lib/workflow/workflow.module";
import { AltoComponentsPageComponent } from "./theme-test/alto-components-page/alto-components-page.component";
import { altoComponentsPageRoute } from "./theme-test/alto-components-page/alto-components-page.route";

@NgModule({
    imports: [
        CommonModule,
        AdaptOrgCommonPagesModule,
        AdaptWorkflowModule,
        AdaptStyledDashboardElementModule,
        AdaptCommonChatAiModule,
    ],
    declarations: [
        AltoComponentsPageComponent,
    ],
    providers: [
        provideChatAiOrgProvider(ChatAiOrgService),
        provideSidebarTab(ChatAiSidebarTab),
        provideApplicationBarItemType(ChatAiApplicationBarItem),
        provideThemeTestPage({ route: altoComponentsPageRoute, title: "2c. Alto Components" }),
    ],
})
export class AdaptAltoAboutModule {
    public static readonly Routes = [
        ...altoComponentsPageRoute.routes,
    ];
}
